import React from "react";
import PropTypes from "prop-types";
import {HelpdeskAPI} from "../../../../api/Helpdesk/HelpdeskAPI";
import {FuxRating} from "../../../../components/FuxRating";
import {EllipsisLoader} from "../../../../components/GenericUI/EllipsisLoader/EllipsisLoader";

export class SessionRatingWidget extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rating: this.props.message.metadata.rating || 0,
            loading: false,
            isRated: false
        }
    }

    handleChange = r => this.setState({rating: r});

    handleSendRating = _ => {
        this.setState({loading: true}, _ => {
            HelpdeskAPI.Admin.Session.setSessionRating(this.props.message.id_messaggio, this.props.message.metadata.session_id, this.state.rating)
                .then(_ => {
                    this.setState({isRated: true});
                })
                .finally(_ => {
                    this.setState({loading: false});
                })
        });

    }

    render() {
        if (this.props.message.metadata.rating || this.state.isRated) {
            return (
                <React.Fragment>
                    <div className={"border-top pt-2 mt-2 text-center"}>
                        <div className={"small"}>Hai valutato la tua esperienza</div>
                        <div>
                            <FuxRating rating={this.state.rating} className={"text-warning"}/>
                        </div>
                    </div>
                </React.Fragment>
            )
        }


        return (
            <React.Fragment>
                <div className={"border-top pt-2 mt-2 text-center"}>
                    <div className={"small"}>Come valuti questa esperienza di assistenza appena conclusa?</div>
                    <div>
                        <FuxRating rating={this.state.rating} className={"text-warning"} onChange={this.handleChange}/>
                    </div>
                    {
                        this.state.rating > 0 &&
                        <React.Fragment>
                            {
                                this.state.loading ?
                                    <EllipsisLoader/>
                                    :
                                    <button className={"btn btn-link"} onClick={this.handleSendRating}>
                                        Invia la tua valutazione
                                    </button>
                            }
                        </React.Fragment>
                    }
                </div>
            </React.Fragment>
        )
    }

}

SessionRatingWidget.propTypes = {
    message: PropTypes.object,
}
